/* eslint-disable react/destructuring-assignment */
import { Tabber } from "nectar-ui";
import React from "react";
import { useSelector } from "react-redux";
import {
  hasActiveLawsuitsByResponsibleBarChartAccess,
  hasDoneActivitiesByMonthStackedBarChartAccess,
  hasDoneActivitiesByResponsibleLineChartAccess,
  hasInProgressActivitiesByResponsibleStackedColumnChartAccess,
  hasLateActivitiesCounterAccess,
  hasLawsuitByCustomerOverTimeColumnChartAccess,
  hasLawsuitCounterAccess,
  hasLawsuitTrackerLineChartAccess,
  hasLawsuitUpdatesCounterAccess,
  hasLawsuitUpdatesRadarChartAccess,
  hasStrategicManagementTabAccess,
} from "./selectors/powersSelectors";

import { dashboardTabSubTypes } from "./utils/constants/dashboard/analyticDashboardEvents";
import LateActivitiesCounter from "./charts/calendar/LateActivitiesCounter";
import { ChartSectionWrapper, DashboardCol, TabWrapper } from "./style";
import LawsuitUpdatesCounter from "./charts/lawsuit/LawsuitUpdatesCounter";
import LawsuitCounter from "./charts/lawsuit/LawsuitCounter";
import LawsuitByCustomerOverTimeColumnChart from "./charts/lawsuit/LawsuitByCustomerOverTimeColumnChart";
import LawsuitUpdatesRadarChart from "./charts/lawsuit/LawsuitUpdatesRadarChart";
import { InProgressActivitiesByResponsibleStackedColumnChart } from "./charts/calendar/InProgressActivitiesByResponsibleStackedColumnChart";
import ActiveLawsuitByResponsibleBarChart from "./charts/lawsuit/ActiveLawsuitsByResponsibleBarChart/ActiveLawsuitsByResponsibleBarChart";
import DoneActivitiesByResponsibleLineChart from "./charts/calendar/DoneActivitiesByResponsibleLineChart";
import LawsuitTrackerLineChart from "./charts/lawsuit/LawsuitTrackerLineChart";
import DoneActivitiesByMonthStackedBarChart from "./charts/calendar/DoneActivitiesByMonthStackedBarChart";
import { sendEventTabOpen } from "./services/dashboardAnalyticEventService";

const DashboardTabsSection = () => {
  const shouldRender = {
    strategicManagementTab: useSelector(hasStrategicManagementTabAccess),
    lateActivitiesCounter: useSelector(hasLateActivitiesCounterAccess),
    doneActivitiesByMonthStackedBarChart: useSelector(
      hasDoneActivitiesByMonthStackedBarChartAccess
    ),
    doneActivitiesByResponsibleLineChart: useSelector(
      hasDoneActivitiesByResponsibleLineChartAccess
    ),
    inProgressActivitiesByResponsibleStackedColumnChart: useSelector(
      hasInProgressActivitiesByResponsibleStackedColumnChartAccess
    ),
    lawsuitUpdatesCounter: useSelector(hasLawsuitUpdatesCounterAccess),
    lawsuitCounter: useSelector(hasLawsuitCounterAccess),
    lawsuitUpdatesRadarChart: useSelector(hasLawsuitUpdatesRadarChartAccess),
    lawsuitTrackerLineChart: useSelector(hasLawsuitTrackerLineChartAccess),
    lawsuitByCustomerOverTimeColumnChart: useSelector(
      hasLawsuitByCustomerOverTimeColumnChartAccess
    ),
    activeLawsuitByResponsibleBarChart: useSelector(hasActiveLawsuitsByResponsibleBarChartAccess),
  };

  const shouldSnapUpLawsuitCounter =
    !shouldRender.lawsuitUpdatesCounter || !shouldRender.lateActivitiesCounter;

  const sendEventToMixpanel = (dashboardTabSubType: string) => {
    sendEventTabOpen(dashboardTabSubType);
  };

  return (
    <Tabber>
      <Tabber.Tab
        onMountCallback={() => sendEventToMixpanel(dashboardTabSubTypes.OFFICE_TAB)}
        title="Visão geral"
      >
        <TabWrapper>
          <ChartSectionWrapper>
            {shouldRender.lateActivitiesCounter && (
              <DashboardCol xs={12} sm={12} md={12} lg={6} style={{ padding: "0 0 0 12px" }}>
                <LateActivitiesCounter />
              </DashboardCol>
            )}
            {shouldRender.lawsuitUpdatesCounter && (
              <DashboardCol xs={12} sm={12} md={12} lg={6}>
                <LawsuitUpdatesCounter />
              </DashboardCol>
            )}
            {shouldRender.lawsuitCounter && (
              <DashboardCol xs={12} sm={12} md={12} lg={shouldSnapUpLawsuitCounter ? 6 : 12}>
                <LawsuitCounter />
              </DashboardCol>
            )}

            {shouldRender.lawsuitByCustomerOverTimeColumnChart && (
              <DashboardCol xs={12} sm={12} md={12} lg={12}>
                <LawsuitByCustomerOverTimeColumnChart />
              </DashboardCol>
            )}
          </ChartSectionWrapper>
        </TabWrapper>
      </Tabber.Tab>
      {shouldRender.strategicManagementTab ? (
        <Tabber.Tab
          onMountCallback={() => sendEventToMixpanel(dashboardTabSubTypes.STRATEGIC_TAB)}
          title="Gestão estratégica"
        >
          <TabWrapper>
            <ChartSectionWrapper>
              {shouldRender.lawsuitUpdatesRadarChart && (
                <DashboardCol xs={12} sm={12} md={12} lg={12} xl={6}>
                  <LawsuitUpdatesRadarChart />
                </DashboardCol>
              )}
              {shouldRender.inProgressActivitiesByResponsibleStackedColumnChart && (
                <DashboardCol xs={12} sm={12} md={12} lg={12} xl={6}>
                  <InProgressActivitiesByResponsibleStackedColumnChart />
                </DashboardCol>
              )}
              {shouldRender.activeLawsuitByResponsibleBarChart && (
                <DashboardCol xs={12} sm={12} md={12} lg={12} xl={6}>
                  <ActiveLawsuitByResponsibleBarChart />
                </DashboardCol>
              )}
              {shouldRender.doneActivitiesByResponsibleLineChart && (
                <DashboardCol xs={12} sm={12} md={12} lg={12} xl={6}>
                  <DoneActivitiesByResponsibleLineChart />
                </DashboardCol>
              )}
              {shouldRender.lawsuitTrackerLineChart && (
                <DashboardCol xs={12} sm={12} md={12} lg={12} xl={12}>
                  <LawsuitTrackerLineChart />
                </DashboardCol>
              )}
            </ChartSectionWrapper>
          </TabWrapper>
        </Tabber.Tab>
      ) : (
        <></>
      )}
      <Tabber.Tab
        onMountCallback={() => sendEventToMixpanel(dashboardTabSubTypes.PERSONAL_TAB)}
        title="Indicadores pessoais"
      >
        <TabWrapper>
          <ChartSectionWrapper>
            {shouldRender.doneActivitiesByMonthStackedBarChart && (
              <DashboardCol xs={12} sm={12} md={12} lg={12}>
                <DoneActivitiesByMonthStackedBarChart />
              </DashboardCol>
            )}
          </ChartSectionWrapper>
        </TabWrapper>
      </Tabber.Tab>
    </Tabber>
  );
};

export default DashboardTabsSection;
